import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController, AlertController } from 'ionic-angular';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';
import { ServiceApiProvider } from '../../providers/service-api/service-api';
import { B06SettingPage } from '../b06-setting/b06-setting';

/**
 * Generated class for the B06aProfileInfoPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-b06a-profile-info',
  templateUrl: 'b06a-profile-info.html',
})
export class B06aProfileInfoPage {

  private todo : FormGroup;
  loading: any;
  Status: any;
  USER_ID:any;
  userData =  { LOGIN: '', PASSWORD:'', USER_NAME:'',
                BRANCH_ID: "", GRP_ID: '', CORP_ID: null, 
                USER_ACTIVE:'YES',
              }
  Password: any = "";
  Password1: any = "";
  Password2: any = "";
  public errorMessage: any = "";
  updatePassword: any = "0";

  constructor(public navCtrl: NavController, public navParams: NavParams,
              public loadingCtrl: LoadingController, private formBuilder: FormBuilder,
              public serviceapi: ServiceApiProvider, public alertCtrl : AlertController) {

    this.todo = this.formBuilder.group({
      username: ['', Validators.required],
      modifypassword: [], 
      password: [],
      password1: [],
      password2: [], 
    });

    this.USER_ID = this.navParams.get('paramID');    //user ID

    let tbl = ["USER"];
    let column = ["USER_ID"];
    let value = [this.USER_ID];
    
    let tblkey = ["No"];
    let fktbl = ["No"];
    let fkkey = ["No"];

    let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);
    let mydata = Object.assign(jsonitem);
    let json_data = this.serviceapi.json_readdata(mydata,"1");
    this.showLoader();
    this.serviceapi.readdata(json_data,"USER","1","1").then((result) => {
        
      this.Status = result["Message"];
      console.log(result["Records"]);
      if (this.Status == "1"){
        this.loading.dismiss();

        let Records = result["Records"];
        this.userData.USER_NAME = Records[0]["USER_NAME"];
        this.userData.CORP_ID = Records[0]["CORP_ID"];
        this.userData.BRANCH_ID = Records[0]["BRANCH_ID"];
        this.userData.GRP_ID = Records[0]["GRP_ID"];
        this.userData.USER_ACTIVE = Records[0]["USER_ACTIVE"];

        console.log(this.userData);
      }
      else {
        this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
        this.loading.dismiss();
      }
    }, (err) => {
        this.errorMessage = "Loading Error. Please try again. Error Code: '" + err + "'";
        this.loading.dismiss();
    });
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad B06aProfileInfoPage');
  }

  save() {
    if (this.validateNoSpecialContain(this.userData.USER_NAME) != true) {
      this.errorMessage = "Username Contains Invalid Characters";
    }
    else {
      if (this.updatePassword == "1") {                         //if update password check box
/*         if(this.Password == "") {
          this.errorMessage = "Please enter Current Password";
        } */
        if (this.Password1 == "") {                             //check password 1 match with password 2
          this.errorMessage = "Please enter New Password";
        }
        else if (this.Password1 != this.Password2) {            //check password 1 match with password 2
          this.errorMessage = "Password Mismatch";
        }
        else {
          this.userData.PASSWORD = this.Password1;              //assign password
          this.callUpdate();
        }
      }
      else {                                                    //no change password
        delete this.userData.PASSWORD;
        this.callUpdate();
      }      
    }
  }

  callUpdate(){
    delete this.userData.CORP_ID;                           //delete branch ID, not use
    delete this.userData.LOGIN;                               //delete login, not use
    delete this.userData.BRANCH_ID;
    this.showLoader();
    console.log(this.USER_ID, this.userData)
    this.serviceapi.updatedata('USER', 'USER_ID', this.USER_ID, this.userData).then((result) => {
        
      this.Status = result["Message"];
      if (this.Status == "1"){
        this.loading.dismiss();
        this.navCtrl.setRoot(B06SettingPage);
      }
      else {
        this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
        this.loading.dismiss();
      }
    }, (err) => {
        this.errorMessage = "Loading Error. Please try again. Error Code: '" + err + "'";
        this.loading.dismiss();
    });
  }

  cancel() {
    this.navCtrl.pop();
  }

  goTo(){
    this.navCtrl.setRoot(B06SettingPage);
  }

  showLoader(){
    this.loading = this.loadingCtrl.create({
        content: 'Loading...',
        duration: 5000,
    });
    this.loading.present();
  }

  updateCheckbox(){
    if (this.updatePassword == "0")
      this.updatePassword = "1";
    else
      this.updatePassword = "0";
  }

  validateNoSpecialContain(s) {
    //Regex for Valid Characters i.e. Alphabets, Numbers.
    var regex = /^[A-Za-z0-9_]+$/

    //Validate TextBox value against the Regex.
    var isValid = regex.test(s);

    return isValid;
  }
}



// WEBPACK FOOTER //
// ./src/pages/b06a-profile-info/b06a-profile-info.ts